import { DatePicker, DatePickerProps } from 'formik-antd';
import styled from 'styled-components';

export default styled(DatePicker)<DatePickerProps>`
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  background-color: #ffffff;
  padding-left: 8px;
  padding-right: 4px;
  &.ant-picker-focused {
    border-color: unset;
    box-shadow: unset;
  }
  &:hover {
    border-color: unset;
  }
  .triangle-down {
    width: 0;
    border-left: 5.5px solid transparent;
    border-right: 5.5px solid transparent;
    border-top: 7px solid var(--arrow-dropdown-color);
    height: 7px;
    display: block;
  }
`;
